import duplicate from "./duplicate";
import redo from "./redo";
import undo from "./undo";
import { insert, insertWithProps } from "./insert";
import deleteB from "./delete";
import wrap from "./wrap";
import unwrap from "./unwrap";
import selectParent from "./select-parent";
import selectChild from "./select-child";
import selectPreviousSibling from "./select-previous-sibling";
import selectNextSibling from "./select-next-sibling";
import moveLeft from "./move-left";
import moveRight from "./move-right";
import { paste, pasteParsed, pasteNewBlocks } from "./paste";
import insertInside from "./insert-inside";
// selectAllChildrens
import selectAllChildrens from "./select-all";
// selectPreviousAfterDelete
import selectPreviousAfterDelete from "./select-previous-after-delete";

export default {
  duplicate,
  redo,
  undo,
  delete: deleteB,
  insert,
  insertWithProps,
  wrap,
  unwrap,
  selectParent,
  selectChild,
  selectPreviousSibling,
  selectNextSibling,
  moveLeft,
  moveRight,
  paste,
  pasteParsed,
  pasteNewBlocks,
  insertInside,
  selectAllChildrens,
  selectPreviousAfterDelete,
};
